import { Modal } from './modal';
let modal;

const initModal = () => {
  modal = new Modal();
};

export {initModal, modal};